// extracted by mini-css-extract-plugin
export default {"container":"helpComp_container__Dws88","title":"helpComp_title__GX0Bd","details":"helpComp_details__R61NR"};